import { Organization, Person } from '../types';

export const filterOrganizations = (orgs: Organization[], searchQuery: string): Organization[] => {
  if (!searchQuery.trim()) {
    return orgs;
  }

  const query = searchQuery.toLowerCase();
  return orgs.filter(
    (org) =>
      org.name?.toLowerCase().includes(query) ||
      org.email?.toLowerCase().includes(query) ||
      org.address?.toLowerCase().includes(query) ||
      org.post_code?.toLowerCase().includes(query) ||
      org.town?.toLowerCase().includes(query) ||
      org.siret?.toLowerCase().includes(query),
  );
};

export const filterPersons = (persons: Person[], searchQuery: string): Person[] => {
  if (!searchQuery.trim()) {
    return persons;
  }

  const query = searchQuery.toLowerCase();
  return persons.filter(
    (person) =>
      person.name?.toLowerCase().includes(query) ||
      person.first_name?.toLowerCase().includes(query) ||
      person.last_name?.toLowerCase().includes(query) ||
      person.email?.toLowerCase().includes(query) ||
      person.phone?.toLowerCase().includes(query) ||
      person.org_name?.toLowerCase().includes(query),
  );
};

export const isPostCodeMissing = (postCode: string | null | undefined): boolean => {
  if (!postCode) return true;
  if (postCode.trim() === '') return true;
  return false;
};

